import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import Alert from "/src/util/alert";

import { TAKS_IMPORT } from "../../../config/lang";

import { call } from "../../../util/action";
import { getStore } from "../../../util/redux/store";
import { translate } from "../../../util/util";

const me = getStore().getState().me;
const ITEMS_PER_PAGE = 50;

export const UploadLogs = () => {
  const [uploadLogs, setUploadLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);

  // Server-side pagination: fetch only the requested page (page_size honored by the
  // actions/ endpoint's LargeResultsSetPagination), using the server's count for paging.
  useEffect(() => {
    getUploadLogs(currentPage);
  }, [currentPage]);

  const getUploadLogs = page =>
    call({ method: "GET", url: `actions/?page=${page}&page_size=${ITEMS_PER_PAGE}` }, data => {
      setUploadLogs(Array.isArray(data?.results) ? data.results : []);
      setTotalCount(data?.count || 0);
    });

  /*
   * @params data any
   * @return string
   */
  const getAMatrixLogData = data => {
    let preparedLogData = "";
    let points = [];
    let productCodes = [];
    const table = [];

    data?.invalid_matrices.map((item, index) => {
      points.push(item.point);
      productCodes.push(...item.products);
    });
    productCodes = [...new Set(productCodes)];
    preparedLogData = `,${points.join()}\n`;

    productCodes?.map(code => {
      let row = [];

      row.push(String(code));
      data?.invalid_matrices.map((item, index) => {
        if (item.products?.includes(code)) {
          row.push("1");
        } else {
          row.push("");
        }
      });
      table.push(row.join());
    });

    preparedLogData += `${table.join("\n")}`;
    // console.log("table", table);
    // console.log("productCodes", productCodes);
    // console.log("preparedLogData", preparedLogData);

    return preparedLogData;
  };

  /*
   * @params data any
   * @return string
  //  */

  const geTaskImportLogData = data => {
    let preparedLogData = "";
    if (data.invalid_tasks?.length) {
      preparedLogData = "Title,Description,Start date,End Date, Point, Network\n";
      preparedLogData += data.invalid_tasks
        .map(logItem => `${logItem.title},${logItem.start},${logItem.end},${logItem.description},${logItem.point},${logItem.network}\n`)
        .join("");
    }

    return preparedLogData;
  };

  const downloadLogs = (data, dataType, fileName, fileType) => {
    let logData = "";

    switch (dataType) {
      case "ASSORTMENT_MATRIX_CREATION":
        logData = getAMatrixLogData(data);
        break;
      case "TASKS_CREATION":
        logData = geTaskImportLogData(data);
        break;
      default:
        console.log(data);
    }

    if (!logData) return;

    let file = new Blob([logData], { type: fileType });
    if (window.navigator.msSaveOrOpenBlob)
      // IE10+
      window.navigator.msSaveOrOpenBlob(file, fileName);
    else {
      // Others
      let a = document.createElement("a"),
        url = URL.createObjectURL(file);
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  };

  const deleteImport = id => {
    call({ method: "DELETE", url: `actions/${id}/delete_action_data/` }, () => {
      Alert.success(translate(TAKS_IMPORT, "download_was_delete_msg", me.language), { position: "bottom-right" });
      // The row isn't removed server-side (its status becomes "deleted"), so refetch the
      // current page to reflect the new status.
      getUploadLogs(currentPage);
    });
  };

  const getStatusClass = status => {
    if (!status) return "";
    const s = status.toLowerCase().replace(/\s/g, "-");
    if (["done", "completed", "success"].includes(s)) return "imp-status-chip--success";
    if (s === "deleted") return "imp-status-chip--deleted";
    return "imp-status-chip--pending";
  };

  if (!uploadLogs.length) return null;

  return (
    <div className="imp-page">
      <div className="table-scroll-x">
        <table className="imp-logs-table">
          <thead>
            <tr>
              <th>{translate(TAKS_IMPORT, "name_title", me.language)}</th>
              <th>{translate(TAKS_IMPORT, "type_tasks_title", me.language)}</th>
              <th>{translate(TAKS_IMPORT, "download_date_title", me.language)}</th>
              <th>{translate(TAKS_IMPORT, "loading_errors_title", me.language)}</th>
              <th className="imp-logs-th--sm">{translate(TAKS_IMPORT, "status", me.language)}</th>
              <th className="imp-logs-th--actions">{translate(TAKS_IMPORT, "remove_btn", me.language)}</th>
            </tr>
          </thead>
          <tbody>
            {uploadLogs?.map((item, index) => (
              <tr key={index}>
                <td>{item.name || "—"}</td>
                <td>{item.type || "—"}</td>
                <td>{item.created ? moment(item.created).format("DD.MM.YYYY HH:mm") : "—"}</td>
                <td>
                  {(item.type !== "TASKS_CREATION" && !_.isEmpty(item.logs)) ||
                  (item.type === "TASKS_CREATION" && item.logs.invalid_tasks?.length) ? (
                    <a
                      className="imp-download-link"
                      onClick={e => {
                        e.preventDefault();
                        downloadLogs(
                          item.logs,
                          item.type,
                          `${item.created ? moment(item.created).format("DD.MM.YYYY HH:mm") : "upload"}-logs.csv`,
                          "csv"
                        );
                      }}>
                      <span className="material-symbols-outlined">download</span>
                      {translate(TAKS_IMPORT, "download_btn", me.language)}
                    </a>
                  ) : (
                    "—"
                  )}
                </td>
                <td>
                  {item.status ? (
                    <span className={`imp-status-chip ${getStatusClass(item.status)}`}>{item.status}</span>
                  ) : "—"}
                </td>
                <td className="imp-logs-td--actions">
                  <button className="imp-btn imp-btn--danger" onClick={() => deleteImport(item.id)}>
                    <span className="material-symbols-outlined">delete</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="imp-pagination">
          <button className="imp-pagination-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(prev => prev - 1)}>
            <span className="material-symbols-outlined">chevron_left</span>
          </button>
          <span className="imp-pagination-counter">{currentPage} / {totalPages}</span>
          <button className="imp-pagination-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage(prev => prev + 1)}>
            <span className="material-symbols-outlined">chevron_right</span>
          </button>
        </div>
      )}
    </div>
  );
};
